<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/16bdPzF/tc-custom/9781569759998.jpg?1724535268060" alt="This image is the cover for the book Green Smoothie Bible"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Green Smoothie Bible
      </h1>
      <p class="bookDescription body article font2">
        <b>From a health and wellness author, a collection of nutrient-rich juice and smoothie recipes that harness the healing power of fruits and vegetables</b><b>.</b><br/>  <br/> You know a daily diet rich in fruits and vegetables can maximize your health and well-being. But did you know that drinking a smoothie every day made from fruits and vegetables can dramatically increase the amount of life-saving nutrients your body takes in? This complete bible of green smoothie recipes shows you how to pack superfoods into every sip with easy-to-make drinks that will help you:<br/>  <br/> • Detoxify your body<br/> • Increase energy<br/> • Fight heart disease<br/> • Burn calories<br/> • Eliminate unwanted processed sugars from your diet<br/> • Boost your immune response<br/> • And even improve the appearance of your skin and hair<br/>  <br/> With more than 300 inviting recipes, <i>The Green Smoothie Bible</i> shows you how to combine leafy green vegetables and delicious, antioxidant-rich fruits into the most nutritious drinks imaginable—leaving you healthy and feeling amazing inside and out. 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kristine Miles
      </h2>
      
      <p class="authorDescription body article">Kristine Miles is a health professional with over 15 years' experience. She is passionate about life-long learning, plant based nutrition and living a low toxic lifestyle. Her mission is 'to promote health and wellbeing, through empowering others to lead lives free of chemicals and full of real, delicious food'. Kristine works full time as a physiotherapist in private practice, is a part time cooking demonstrator, and blogger. She is happily married and lives on Phillip Island, Victoria, Australia.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Ulysses Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?05303a8f